function getCartItems() {
  const loader = document.querySelector(".loader");

  loader.style.display = "inline-flex";

  fetch("/cart.js")
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      loader.style.display = "none";
      renderCartItems(data.items);
      updatePriceAndCount(data);
    })
    .catch((error) => {
      console.error("There was a problem with the fetch operation:", error);
      loader.style.display = "none";
    });
}

function renderCartItems(cartItems) {
  const cartItemsContainer = document.querySelector("#cart_items_container");
  const cartEmptyState = document.querySelector(".header__cart__empty");
  const checkoutButton = document.querySelector("#cart_drawer_checkout_btn");

  if (cartItems.length == 0) {
    cartItemsContainer.innerHTML = "";
    cartEmptyState.style.display = "block";
    checkoutButton.classList.add("isDisabled");
    return;
  }
  checkoutButton.classList.remove("isDisabled");

  let newHTML = "";
  cartItems.forEach((item) => {
    const originalPriceSnippet = `
      <div class="product__price--old">
        ${formatPrice(item.original_price)}
      </div>
    `;
    const tags = `
    <div class="cart__tags">
    ${
      item.discounts.length > 0 &&
      item.discounts.map((discount) => {
        return discount.amount == 0
          ? ""
          : `
          <div class="cart__tags__tag">
            <svg
              width="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M7.5 7.5H7.51M21.09 13.91L13.92 21.08C13.7343 21.266 13.5137 21.4135 13.2709 21.5141C13.0281 21.6148 12.7678 21.6666 12.505 21.6666C12.2422 21.6666 11.9819 21.6148 11.7391 21.5141C11.4963 21.4135 11.2757 21.266 11.09 21.08L2.5 12.5V2.5H12.5L21.09 11.09C21.4625 11.4647 21.6716 11.9716 21.6716 12.5C21.6716 13.0284 21.4625 13.5353 21.09 13.91Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>
              ${discount.title} (-${formatPrice(discount.amount)})
            </span>
          </div>
      `;
      })
    }
    </div>
    `;

    newHTML += `
      <form
        novalidate="novalidate"
        class="mb-4"
        id="form_${item.id}"
        action="/cart/change"
        method="post"
      >
        <div
          class="card card--cart"
        >
          <input type="hidden" name="line" value="${item.id}">
          <input
            id="product_id_${item.id}"
            type="hidden"
            name="id"
            value="${item.id}"
          >
          <div class="card__image__container" style="flex-shrink: unset">
            <span
              class="card__image__link"
            >
              <img
                class="card__image"
                src="${item.image}&crop=center&height=150&width=150"
                alt="product image"
                width="150"
                height="150"
                loading="eager"
              >
            </span>
          </div>
          <div class="card__body">
            <div class="card__body__container">
              <div>
                <div class="product__title--sm">${item.product_title}</div>

                <div class="card__description">
                  ${item.variant_title ? item.variant_title : item.product_type}
                </div>
                <div>
                ${item.discounts.length > 0 ? tags : ""}
                </div>
              </div>
              <div id="price-${item.id}" class="product__price">
                ${
                  item.original_price > item.discounted_price
                    ? originalPriceSnippet
                    : ""
                }
                <div class="product__price--current--sm">
                  ${formatPrice(item.discounted_price)}
                </div>
              </div>
            </div>
            <div class="cart-actions">
              <div class="cart-actions__counter cart-actions__counter--secondary">
                <span
                  class="cart-actions--icon cart-actions--icon--minus"
                  onclick="decrease('${item.id}'); handleWait(this);"
                  id="decrease"
                >
                  <svg
                    width="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.33398 8H12.6673"
                      stroke="#101828"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </span>
                <input
                  class="cart-actions__input"
                  type="number"
                  name="quantity"
                  value="${item.quantity}"
                  min="1"
                  id="quantity_${item.id}"
                  aria-label="Quantity"
                >
                <span
                  class="cart-actions--icon cart-actions--icon--plus"
                  onclick="increase(${item.id}); handleWait(this);"
                  id="increase"
                >
                  <svg
                    width="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.00065 3.33398V12.6673M3.33398 8.00065H12.6673"
                      stroke="#101828"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </span>
              </div>
              <span
                onclick="removeItem(${item.id})"
                class="btn btn--base btn--outline btn--square"
              >
                <svg
                  width="20"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M2.5 5.49935H4.16667M4.16667 5.49935H17.5M4.16667 5.49935V17.166C4.16667 17.608 4.34226 18.032 4.65482 18.3445C4.96738 18.6571 5.39131 18.8327 5.83333 18.8327H14.1667C14.6087 18.8327 15.0326 18.6571 15.3452 18.3445C15.6577 18.032 15.8333 17.608 15.8333 17.166V5.49935H4.16667ZM6.66667 5.49935V3.83268C6.66667 3.39065 6.84226 2.96673 7.15482 2.65417C7.46738 2.34161 7.89131 2.16602 8.33333 2.16602H11.6667C12.1087 2.16602 12.5326 2.34161 12.8452 2.65417C13.1577 2.96673 13.3333 3.39065 13.3333 3.83268V5.49935M8.33333 9.66602V14.666M11.6667 9.66602V14.666" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </form>
    `;
    cartItemsContainer.innerHTML = newHTML;
    cartEmptyState.style.display = "none";
  });
}